export default function RailHeaderController(
    $scope, $controller, railsFactory
) {
    'ngInject';

    $controller('RailHeaderBaseController', {
        $scope,
        railsFactory,
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/controllers/ukrailHeaderCtrl.js